import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const RequestFor = () => {
  return(
    <SettingsMetaData propertyName={"RequestFor"} viewPropertyName={"Request For"} />
  )
};

export default RequestFor;
